import Vue from 'vue';
import Router from 'vue-router';
import Error404 from '@/views/Error404';
// import Home from './views/Home.vue';

Vue.use(Router);



// https://github.com/PanJiaChen/vue-admin-template
export default new Router({
   routes: [
      {
         path: '/',
         name: 'home',
         //component: Home
         component: () => import('@/views/Default')
      },

      {
         path: '/about',
         name: 'about',
         // route level code-splitting
         // this generates a separate chunk (about.[hash].js) for this route
         // which is lazy-loaded when the route is visited.
         component: () => import(/* webpackChunkName: "about" */ '@/views/Default')
      },
      {
         path: '*',
         component: Error404
      }
   ]
});
